import React, { useState, useEffect } from 'react'
import _ from 'lodash'
import styled from 'styled-components/macro'
import { Col } from 'styled-bootstrap-grid'
import { Popover } from 'antd'
import { Profile, ProfilePhoto } from '../../features/profile/types'
import { Title } from '../../components/Text'
import { getPhotofromId } from '../../api/profile'

const ProfileItemWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 10px;
  .profile-avatar {
    width: 245px;
    height: 245px;
    border-radius: 20px;
  }
`

type Props = {
  profile: Profile
}

export const PhotoImage = ({ imageId, width }: { imageId: string; width: number }) => {
  const [image, setImage] = useState(null)

  useEffect(() => {
    const LoadImage = async () => {
      const photo = await getPhotofromId(imageId)
      await setImage(photo.data)
    }

    LoadImage()
  }, [imageId])

  return image && <img key={`${imageId}2`} src={`data:image/jpeg;base64,${image}`} alt={imageId} width={width} />
}

export const ProfileItem = ({ profile }: Props) => {
  return (
    <Col md={4}>
      <ProfileItemWrapper>
        <Title size="M">{`( ID:  ${profile.id} ) ${profile.name}, ${profile.age}`}</Title>
        <img className="profile-avatar" src={_.replace(profile.photo_url, 'info', 'media')} alt={profile.name} />
        <div>
          {_.map(profile.photos, (photo: ProfilePhoto) => {
            const content = <PhotoImage imageId={photo.id} key={photo.id} width={200} />
            return (
              <Popover content={content} key={`pop-${photo.id}`} placement="top">
                <span>
                  <PhotoImage imageId={photo.id} key={photo.id} width={40} />
                </span>
              </Popover>
            )
          })}
        </div>
      </ProfileItemWrapper>
    </Col>
  )
}
